import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppConsts } from "@shared/app-consts";
import { BaseService } from "@services/base.service";
import { UserFeatureType } from "@shared/user/user-feature-type.enum";

@Injectable({
  providedIn: "root",
})
export class UserFeatureService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  hasFeature(featureType: UserFeatureType, companyId: number): Observable<boolean> {
    let httpOptions = this.getHttpHeader(false, {
      feature: featureType,
      companyId: companyId
    });

    return this.http.get(
      AppConsts.API_SERVICE_URL + `UserFeature/HasFeature`,
      httpOptions
    ) as Observable<boolean>;
  }
}
